export default __webpack_public_path__ + "/assets/vivi-partner-marazzi-lg.jpg";